export default "__VITE_ASSET__D$Mrld3F__"